import { AsanSignResponse, AsanSignSession } from './types';

/** Maps a sign API response to the session AsanConfirmation needs. */
export const toAsanSession = (response?: AsanSignResponse | null): AsanSignSession => ({
  pathUrl: response?.path_url,
  businessKey: response?.business_key,
  verifyCode: response?.verification_code,
  timerTime: response?.timer,
});
